export const parseTime = (time?: number | null | undefined) => {
  if (!time) return [];
  const hour = Math.floor(time / 3600);
  const minute = Math.floor((time % 3600) / 60);
  return [hour, minute];
};

export const isUpdatedMoreThan15HoursAgo = (updatedDate: number | null | undefined): boolean => {
  if (!updatedDate) return false;

  const now = Date.now();

  const fifteenHoursAgo = now - 15 * 60 * 60 * 1000;

  return updatedDate > fifteenHoursAgo;
};
